import { useTranslation } from 'react-i18next';
import { EApiType, EDataTableType, EModuleType } from '../../../data/Constants';
import { MaintenanceTable } from '../../DataTable/DataTable';
import { useApiError } from '../../../hooks';
import { formatLogContent } from '../../DataTable/Helper/DataTableHelper';
import { getProductVersionMapping } from '../../../store/states/ProductVersionMappingSlice';
import type { IManagementProps } from '../../../../types';

export const ProductVersionMappingManagement = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.ProductVersionMappingKey);

  if (errorElement) {
    return errorElement;
  }

  return (
    <>
      <h3 className="mainHeader">{t('labels.productVersionMappingManagement')}</h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.ProductVersionMapping}
        getDataList={getProductVersionMapping}
        moduleType={EModuleType.Notifications}
        getLogContent={formatLogContent}
      />
    </>
  );
};
